// 统一出口
// api文件夹下 各个请求模块js, 都统一来到index.js再向外导出

import { getPhotos } from './getPhotos'
import { getResults } from './getResults'
import { check } from './check'
import { calculate } from './calculate'
import { getUserInfo } from './getUserInfo'
import { getPageInfo } from './getUserInfo'
import { findPic } from './findPic'
import { getRank1, getRank2, getRank3, getRank4 } from './getRank'
import { webIfon } from './webIfon'
import { expertImg, expertImg2, getAnomalousImages, subAnomalousImages } from './expertImg'
import { expert } from './experts'
import { Mapping } from './Mapping'
import { Text } from './Text'
import { expertCheck } from './expertCheck'
import { ranking } from './ranking'
import { getAnnotationBatch, submitAnnotationBatch, getAnnotationProgress, listAnnotationProjects, selectAnnotationProject, getProjectSiteProgress } from './annotationBatch'
import { galaxyAnalyze, galaxyAnalyzeStream, galaxyChat, galaxyChatStream } from './galaxyAnalysis'

export const checkAPI = check //校验
export const getPhotosAPI = getPhotos //获取图片
export const getResultsAPI = getResults //提交结果
export const calculateAPI = calculate //获取个人中心指标接口
export const getUserInfoAPI = getUserInfo //查看用户指标
export const getPageInfoAPI = getPageInfo //分页查看用户信息
export const findPicAPI = findPic //分页查看用户信息
export const getRank1API = getRank1 //分类总数
export const getRank2API = getRank2 //异常总数
export const getRank3API = getRank3 //平均完整率
export const getRank4API = getRank4 //平均完整率
export const webIfonAPI = webIfon//统计
export const expertAPI = expert//判断专家接口
export const expertImgAPI = expertImg//专家接口
export const expertImg2API = expertImg2//专家接口上一张
export const getAnomalousImagesAPI = getAnomalousImages//专家异常图片获取
export const subAnomalousImagesAPI = subAnomalousImages//专家异常专区提交
export const MappinggAPI = Mapping
export const TextAPI = Text //我的成就txt文件渲染
export const expertCheckAPI = expertCheck //判断是否是专家
export const rankingAPI = ranking //我的成绩查排名
// 批量标注API
export const getAnnotationBatchAPI = getAnnotationBatch //获取当前批次图片
export const submitAnnotationBatchAPI = submitAnnotationBatch //提交批次并更新进度
export const getAnnotationProgressAPI = getAnnotationProgress //获取标注进度
export const listAnnotationProjectsAPI = listAnnotationProjects //可选标注项目
export const selectAnnotationProjectAPI = selectAnnotationProject //选定标注项目
export const getProjectSiteProgressAPI = getProjectSiteProgress //项目全站标注统计
export const analyzeGalaxyAPI = galaxyAnalyze //星系分析
export const analyzeGalaxyStreamAPI = galaxyAnalyzeStream //流式星系分析
export const chatGalaxyAPI = galaxyChat //AI对话
export const chatGalaxyStreamAPI = galaxyChatStream //流式AI对话
